import React from 'react'

import { createRegisterableComponent } from 'common/routing/page-definition'
import { FeatureHeadline } from './FeatureHeadline'

export interface FeatureHeadlingProps {
    text: string
    isExclusive: boolean
}

export const FeatureHeadlineRegistration = createRegisterableComponent(
    'feature-headline',
    (props: FeatureHeadlingProps) => {
        return <FeatureHeadline text={props.text} isExclusive={props.isExclusive} />
    }
)
